<template>
  <div v-show="show" :style="{ 'z-index': (currentZIndex-1)}">
    <div :style="{ 'z-index': (currentZIndex)}"
      class="dimmed_black" style="top:0;display:block;"></div>
    <!--popup 시작-->
    <div :style="{ 'z-index': (currentZIndex+1)}"
      class="rew19_popContainer big" id="pop_landNumber" style="display: block">
      <div class="rew19_popup_wrap">
        <h2>
          <span class="rew19_basketList_tit">우편번호/ 주소 찾기</span>
          <button class="rew19_basketList_btn" @click="onCancel"><span>닫기</span></button>
        </h2>
      </div>
      <div class="rew19_popup_cont post">
        <ul class="rew19_tab_pop nav nav-tabs nav-stacked">
          <!--<li class=""><a href="#zipCodeTabJibun" data-toggle="tab" aria-expanded="false">지번 검색</a></li>-->
          <li class="active" style="width: 100%;"><a>도로명 검색</a></li>
        </ul>      
        <div class="tab-content rew19_tabCont">         
          <div class="tab-pane zipCodeTabPane" style="display: block">
            <dl class="rew19_select_table">
              <dt>
                <div class="address_btn_box">
                  <input v-model.trim="keyword" @keydown.enter="loadData(1);"                   
                    type="text" class="rew19_inputTxt_t1" placeholder="검색 하고자 하는 도로명 혹은 건물명을 입력하세요. (예: 봉은사로 86길)">
                  <a @click="loadData(1);" class="rew19_btn_T1" style="top: 7px;">조회</a>
                </div>
              </dt>
            </dl>
            <dl class="rew19_select_table">
              <dd v-if="!addrInfo.results || addrInfo.results.length < 0">조회된 내용이 없습니다.</dd>
              <dd v-for="(item, idx) in addrInfo.results" :key="idx">
                <a @click="onSetAddr(item)" class="addrInfo">
                  <em>{{item.postcode5}}</em>
                  <span>{{item.ko_common}} {{item.ko_doro_dongri}}</span>
                </a>
              </dd>
            </dl>
          </div>
        </div>

        <page-nav
          ref="pageNav"
          :totalItemCount="addrInfo.totalDataCount"
          :pageNo="addrInfo.page"
          :itemCountPerPage="addrInfo.count"
          :pageGroup="5"
          @onClickPage="onClickPage"
        ></page-nav>
      </div><!--//rew19_popup_cont-->
      <div class="rew19_popup_btn">
        <button class="rew19_popFull disabled" @click="onCancel">닫기</button>
      </div>
    </div>
  </div>  
</template>
<script>
import * as Const from "@/utils/const";
import * as ErrMsg from "@/utils/error_msg";
import PageNav from "@/components/paging/pageNav";

export default {
  name: 'FindAddressDialog',
  components: { PageNav },
  computed: {
    isNuskinChannel : function() {
      return this.$aroChannel == Const.ARO_CHANNEL_NUSKIN;
    },
    isMeCommerceChannel : function() {
      return this.$aroChannel == Const.ARO_CHANNEL_ME_COMMERCE;
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    rowPerPage : {
      type : Number,
      default: 10
    }
  },
  data() {
    return {      
      currentZIndex : 2000,

      keyword : null,

      addrInfo : {
        count: 5,
        page: 1,
        totalDataCount: 0,
        results : []
      }
    }
  },
  watch: {
    show(show) {
      this.$modalAfterTreat(show);
      
      show && this.$nextTick(() => {
        let _this = this;
        _this.currentZIndex = _this.$getDimmMaxIndex() + 2;

        this.$el.focus();
      })
    }
  },
  updated: function () {
    this.$nextTick(function () {
      $(".rew19_popContainer.big .rew19_popup_cont").css('height', $(window).height() - 102); 
    })
  },
  mounted() {
    let _this = this;
  },  
  methods :{
    onClose(response) {
      let _this = this;
      
      _this.$emit('setData', response, null);
    },
    onCancel(){
      this.onClose(false);
    },
    onSetAddr(item) {
      let _this = this;

      _this.$emit('setData', true, item);
    },

    /**
     * API Request
     */    
    //주소 데이터 로드
    apiGetZipcode : function(pageNo){
      let _this = this;

      return _this.$http.get(`${_this.$zipApiBasePath}`, {
        params: {
          keywords: _this.isNuskinChannel ? encodeURI(_this.keyword) : _this.keyword,
          pageNo: pageNo,
          rowNum: _this.rowPerPage,
        },
        paramsSerializer: function (params) {
          return require('qs').stringify(params, {arrayFormat: 'brackets'})
        },       
      });
    },

    /**
     * Local 
     */
    initData : function(paramData){
      let _this = this;

      _this.addrInfo.page = 1;
      _this.addrInfo.count = _this.rowPerPage;
      
      //Pass Paging info
      _this.$refs.pageNav.resetVal(
        _this.addrInfo.totalDataCount,
        _this.addrInfo.page,
        _this.rowPerPage,
      );
    },

    loadData : function(reqPageNo){
      let _this = this;

      _this.$showLoading();      
      _this.apiGetZipcode(reqPageNo).then(res=>{
        console.debug(res);

        if(res.status === 200 && res.data.result){
          //console.debug(res.data);        

          _this.addrInfo = {...res.data.roadAddrData};
          _this.addrInfo.page = reqPageNo;

          //Pass Paging info
          _this.$refs.pageNav.resetVal(
            _this.addrInfo.totalDataCount,
            _this.addrInfo.page,
            _this.rowPerPage,
          );
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          throw errMsg;
        }        

      }).catch((err)=>{
        console.error(err);

        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    onClickPage(pageNo){
      let _this = this;

      _this.loadData(pageNo);
    }
  }
}
</script>
<style>
.address_btn_box a, a.addrInfo{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/FindAddressDialog.vue